import { render, staticRenderFns } from "./noteedit.vue?vue&type=template&id=21fb4c56"
import script from "./noteedit.vue?vue&type=script&lang=js"
export * from "./noteedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports